import { useMemo } from 'react';
import mitt from 'mitt';
import EventEmitterContext from "../context/EventEmitterContext.js";
/** Provider for EventEmitterContext. */
import { jsx as _jsx } from "react/jsx-runtime";
export default function EventEmitterProvider(_ref) {
  let {
    children
  } = _ref;
  const emitter = useMemo(() => mitt(), []);
  return /*#__PURE__*/_jsx(EventEmitterContext.Provider, {
    value: emitter,
    children: children
  });
}